<template>
  <v-dialog v-if="show_cart" style="z-index:99;" fullscreen scrollable transition="dialog-bottom-transition" :overlay="false">
    <Cart />
  </v-dialog>
</template>

<script>
import {firebase, db, auth, store} from '@/fb';
import { getRandomInt, randomString, getCDate, check } from '@/customFunction';
import axios from 'axios';
let apiBase = 'https://us-central1-ashyaatcrm.cloudfunctions.net/main'
const headers = {'Accept': 'application/json'};
import Cart from '@/components/Cart'

export default {
  components: {Cart},
  data(){
    return {
      
    }
  },
  methods: {
    loadCities(c){
      this.newLead.city = null
      this.cities=c.cities
      // console.log(c)
    },
    setCookie(name, value, days) {
      var expires = "";
      var maxAge = "";
      if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
        maxAge = "; max-age=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "") + expires + "; path=/";
    },
    getCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    },
    isNumber(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    hideCart() {
      this.$store.dispatch('closeCart')
    },
    getProductTotals(p) {
      this.$store.dispatch('getProductTotals', p)
    },
    removeFromCart(p) {
      this.$store.dispatch('removeFromCart', p)
    },
    increaseQuantity(p){
      this.$store.dispatch('increaseQuantity', p)
    },
    decreaseQuantity(p){
      this.$store.dispatch('decreaseQuantity', p)
    },
    scrollDown(){
      var container = document.querySelector(".v-dialog--scrollable");
      container.scrollTop = container.scrollHeight;
    },
    syncCustomer(){
      if (this.customer && this.customer.name) {
        this.name = this.customer.name
      }
      if (this.customer && this.customer.phone) {
        this.phoneNumber = this.customer.phone
      }
    },
    checkPhone() {
      this.phoneNumber = this.newLead.phone_number_1
      if(!this.newLead.phone_number_1 || !this.newLead.country) {
        return false
      }
      if(this.phoneNumber) {
        this.phoneNumber = this.phoneNumber.replace(/[٠١٢٣٤٥٦٧٨٩]/g, function (d) {
          return d.charCodeAt(0) - 1632;                
        }).replace(/[۰۱۲۳۴۵۶۷۸۹]/g, function (d) { return d.charCodeAt(0) - 1776; })
      }
      
      return axios.get(`https://us-central1-ashyaatcrm.cloudfunctions.net/ash_phone/vPhone?phone=${encodeURI(this.phoneNumber)}&cc=${this.newLead.country.alpha2Code}`)
      .then(resp=>{
        if(resp.data.corrected && resp.data.g && resp.data.g.isValidNumber) {
          return this.phoneNumber = resp.data.corrected ? resp.data.corrected : this.phoneNumber
        } else {
          this.$emit('snackbarNotification', `Please correct your phone number`, 'error')
          return false
        }
      })
    },
    async checkNumberBlocked(cip){
      return new Promise(async (res, rej)=>{
        let a = await db.ref('blocknumberlist').once('value').then(x=>x.val())
        if(a) {
          let b = Object.values(a)
          let c = b.map(x=>x.number)
          // console.log(cip)
          if(c.includes(`${cip}`)){
            res(true)
          } else {
            res(false)
          }
        } else {
          res(false)
        }
      })
    },
    validate(){
      if (!this.cart.length) {
        this.$emit('snackbarNotification', this.i18n["cart_empty"], 'error')
        return false
      }
      if (!this.newLead.name) {
        this.$emit('snackbarNotification', this.i18n["name_required"], 'error')
        return false
      }
      if (!this.newLead.phone_number_1) {
        this.$emit('snackbarNotification', this.i18n["phone_required"], 'error')
        return false
      }
      if (!this.newLead.country) {
        this.$emit('snackbarNotification', this.i18n["country_required"], 'error')
        return false
      }
      if (!this.newLead.city) {
        this.$emit('snackbarNotification', this.i18n["city_required"], 'error')
        return false
      }
      if (!this.newLead.address) {
        this.$emit('snackbarNotification', this.i18n["address_required"], 'error')
        return false
      }
      if (!this.newLead.business_name) {
        this.$emit('snackbarNotification', this.i18n["business_name_required"], 'error')
        return false
      }
      if (!/^[A-Za-z][A-Za-z0-9 ]*$/.test(this.newLead.business_name)) {
        this.$emit('snackbarNotification', this.i18n["business_name_required_in_english"], 'error')
        return false
      }
      if (this.newLead.business_name && this.newLead.business_name.length > 20) {
        this.$emit('snackbarNotification', this.i18n["max_20_chars"], 'error')
        return false
      }
      return true
    },
    async submitOrder(){
      this.$store.state.loading = true
      let nDate = await axios.get(`${apiBase}/getDate`).then(x=>x.data.date)
      let m = await this.checkPhone()
      let fraud_check = false
      
      if(this.validate() && m) {
        let order = []
        let cart = this.cart
        let item_name_collector = ``
        for (let i = 0; i < cart.length; i++) {
          const item = cart[i];
          let p = {
            product:item.item_name,
            price:item.price_name,
            sku:item.sku,
            discount:0,
            id:item.id,
            baseprice:item.base_price,
            quantity:item.order_quantity,
            variant:item.variant,
            total:item.total,
          }
          if(item.variant) {
            // console.log('item.variant', item.variant)
            p.product = item.variant.name
            p.sku = item.variant.sku
          }
          item_name_collector += `${item.order_quantity} X | ${item.sku} - ${item.name_ar}\n`
          order.push(p)
        }
        let data = {
          
          ///
          business_name:this.newLead.business_name,
          name:this.newLead.name,
          language:this.language,
          country_object:this.newLead.country,
          city:this.newLead.city.name,
          city_object:this.newLead.city,
          cc:this.newLead.country.alpha2Code,
          country:this.newLead.country.name,
          phone_number_1:this.newLead.phone_number_1,
          phone_number_2:this.newLead.phone_number_2,
          campaign_code:order.map(x=>x.sku).join('|') + ` BAYAA3`,
          total:this.cart_total,
          delivery_fees:this.cart_delivery_fees,
          tax:this.cart_tax,
          address:this.newLead.address,
          note:this.newLead.note,
          date:nDate,
          timestamp:new Date().getTime(),
          import_date:nDate,
          order_status:'NEW',
          item_name: order.map(x=>x.sku).join(' | ') + '\n\r' + item_name_collector + '\n\r' + 'TOTAL:' + parseFloat(this.cart_total),
          ip:this.location.ip,
          order,
          token:`${randomString(3, 'Aa')}-${randomString(6, 'Aa')}`,
          order_source:'BAYAA',
          ////
          company_code:'BAYAA'
        };
        let key  = await db.ref(`uKeys`).push()
        data.key = key.key
        // console.log('lead', data)
        // let mss = await store.collection('leads').doc(key.key).set(data)
        try {
          let larastore = await axios.post('https://yervip.com/api/v1/leads', data, {headers}).then(x=>x.data)
          // console.log('larastore', larastore)
        } catch (error) {
          // console.log('larastore error', error)
        }
        try {
          data.key = data.key
          // let automation = await axios.post(`${apiBase}/newLeads`, data, {headers}).then(x=>x.data)
          // console.log('automation', automation)
        } catch (error) {
          // console.log('automation error', error)
        }
        
        this.hideCart()
        this.$store.state.thank_you = true
        setTimeout(x=>{
          this.$store.state.loading = false
        }, 2000)
        setTimeout(x=>{
          this.$store.state.thank_you = false
        }, 12000)
      } else {
        this.$store.state.loading = false
      }
    },
  },
  watch:{
    cart(){
      if(this.cart.length < 1) {
        this.hideCart()
      }
    }
  },
  computed:{
    show_cart(){
      if(!this.newLead.country) {
        this.newLead.country = this.$store.state.country
      }
      if(!this.cities || !this.cities.length) {
        // console.log('mounted country of state', this.$store.state.country)
        this.loadCities(this.$store.state.country)
      }
      return this.$store.state.show_cart
    },
  },
  mounted(){
  },
  created(){
  }
}
</script>
